/* Anavadhya — scroll reveals, the saree "unfold" section, recently viewed sarees
   and the Judge.me reviews section.
   Everything here is progressive: without JS (or with reduced motion) the
   content is simply shown in full. */
(function () {
  'use strict';

  window.anvReady = true;
  var root = document.documentElement;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = root.classList.contains('shopify-design-mode') || (window.Shopify && window.Shopify.designMode);

  /* ---------- Reveal on scroll ("unfurl") ---------- */
  var observer = null;
  var watched = new Map();

  function revealAll(scope) {
    (scope || document).querySelectorAll('.anv-reveal, .anv-rise').forEach(function (el) {
      el.classList.add('is-in');
    });
  }

  function watchReveals(scope) {
    var els = (scope || document).querySelectorAll('.anv-reveal:not(.is-in), .anv-rise:not(.is-in)');
    if (!els.length) return;
    if (reduceMotion || designMode || !('IntersectionObserver' in window)) {
      revealAll(scope);
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            (watched.get(entry.target) || []).forEach(function (el) { el.classList.add('is-in'); });
            watched.delete(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    }
    // A fully clipped element never reports as visible, so watch its parent instead.
    els.forEach(function (el) {
      var target = el.classList.contains('anv-reveal') && el.parentElement ? el.parentElement : el;
      var list = watched.get(target);
      if (!list) { list = []; watched.set(target, list); observer.observe(target); }
      if (list.indexOf(el) === -1) list.push(el);
    });
  }

  /* ---------- Saree unfold ---------- */
  var unfolds = [];
  var ticking = false;

  function clamp(n, min, max) { return Math.min(max, Math.max(min, n)); }

  // Height of the theme's pinned header, so the saree sits just below it instead of under it.
  function stickyHeaderOffset() {
    var header = document.querySelector('.header-section');
    if (!header) return 0;
    var cs = window.getComputedStyle(header);
    if (cs.position !== 'sticky' && cs.position !== 'fixed') return 0;
    var top = parseFloat(cs.top) || 0;
    return Math.max(0, Math.round(header.offsetHeight + top));
  }

  function updateUnfold(section) {
    var offset = stickyHeaderOffset();
    if (section.__anvOffset !== offset) {
      section.__anvOffset = offset;
      section.style.setProperty('--anv-sticky-top', offset + 'px');
    }
    var sticky = section.querySelector('.anv-unfold__sticky');
    var rect = section.getBoundingClientRect();
    var travel = section.offsetHeight - (sticky ? sticky.offsetHeight : window.innerHeight);
    if (travel <= 0) {
      section.style.setProperty('--p', '1');
      return;
    }
    // Start unrolling once the section reaches the header; leave a small rest at the end.
    var raw = clamp((offset - rect.top) / travel, 0, 1);
    var p = clamp(raw / 0.9, 0, 1);
    // ease-out so the cloth slows as it lays flat
    var eased = 1 - Math.pow(1 - p, 2);
    section.style.setProperty('--p', eased.toFixed(4));

    var captions = section.querySelectorAll('[data-at]');
    var active = null;
    captions.forEach(function (c) {
      if (eased >= parseFloat(c.getAttribute('data-at'))) active = c;
    });
    captions.forEach(function (c) { c.classList.toggle('is-on', c === active); });
    section.classList.toggle('is-done', eased >= 0.97);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      ticking = false;
      unfolds.forEach(updateUnfold);
    });
  }

  function setupUnfolds(scope) {
    var found = (scope || document).querySelectorAll('[data-anv-unfold]');
    found.forEach(function (section) {
      if (unfolds.indexOf(section) === -1) unfolds.push(section);
      if (reduceMotion || designMode) {
        section.style.setProperty('--p', '1');
        section.classList.add('is-done');
        section.querySelectorAll('[data-at]').forEach(function (c) { c.classList.add('is-on'); });
      } else {
        updateUnfold(section);
      }
    });
    // drop sections that were removed (theme editor)
    unfolds = unfolds.filter(function (s) { return document.body.contains(s); });
  }

  /* ---------- Recently viewed (kept on the visitor's device only) ---------- */
  var RECENT_KEY = 'anv:recent';
  var RECENT_MAX = 12;

  function readRecent() {
    try {
      var list = JSON.parse(window.localStorage.getItem(RECENT_KEY) || '[]');
      if (!Array.isArray(list)) return [];
      return list.filter(function (h) { return typeof h === 'string' && h.length < 256 && /^[^\s\/?#]+$/.test(h); });
    } catch (e) {
      return [];
    }
  }

  function writeRecent(list) {
    try { window.localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, RECENT_MAX))); } catch (e) { /* storage unavailable */ }
  }

  var recorded = false;
  function recordView() {
    if (recorded) return;
    var el = document.querySelector('[data-anv-product][data-handle]');
    if (!el) return;
    recorded = true;
    var handle = el.getAttribute('data-handle');
    var list = readRecent().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    writeRecent(list);
  }

  function storeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function fillRecent(section) {
    if (section.__anvRecent) return;
    section.__anvRecent = true;
    var list = section.querySelector('[data-anv-recent-list]');
    var hint = section.querySelector('[data-anv-recent-hint]');
    var clear = section.querySelector('[data-anv-recent-clear]');
    var limit = parseInt(section.getAttribute('data-limit'), 10) || 4;
    var exclude = section.getAttribute('data-exclude');
    var handles = readRecent().filter(function (h) { return h !== exclude; }).slice(0, limit);

    if (clear) {
      clear.hidden = !handles.length;
      clear.addEventListener('click', function () {
        writeRecent([]);
        if (list) list.innerHTML = '';
        clear.hidden = true;
        if (hint) hint.hidden = false;
        if (!designMode) section.hidden = true;
      });
    }
    if (!handles.length || !list || !window.fetch) return;

    Promise.all(handles.map(function (handle) {
      var url = storeRoot() + 'products/' + encodeURIComponent(handle) + '?section_id=anv-card-fragment';
      return fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (res) {
          if (res.status === 404) return { gone: handle };
          return res.ok ? res.text() : null;
        })
        .catch(function () { return null; });
    })).then(function (results) {
      var gone = [];
      var frag = document.createDocumentFragment();
      var count = 0;
      results.forEach(function (res) {
        if (res && res.gone) { gone.push(res.gone); return; }
        if (typeof res !== 'string') return;
        var tpl = document.createElement('template');
        tpl.innerHTML = res;
        var card = tpl.content.querySelector('.anv-card');
        if (!card) return;
        var li = document.createElement('li');
        li.appendChild(card);
        frag.appendChild(li);
        count++;
      });
      if (gone.length) writeRecent(readRecent().filter(function (h) { return gone.indexOf(h) === -1; }));
      if (!count) return;
      list.innerHTML = '';
      list.appendChild(frag);
      if (hint) hint.hidden = true;
      if (clear) clear.hidden = false;
      section.hidden = false;
      watchReveals(section);
    });
  }

  /* ---------- Reviews: show the section once Judge.me (or an app block) has loaded ---------- */
  function setupReviews(scope) {
    (scope || document).querySelectorAll('[data-anv-reviews]').forEach(function (section) {
      if (designMode) { section.classList.add('is-ready'); return; }
      if (section.__anvReviews) return;
      section.__anvReviews = true;
      var tries = 0;
      (function check() {
        var hasApp = !!section.querySelector('.anv-rv__app *');
        var hasJudgeMe = !!(window.jdgm && section.querySelector('.jdgm-widget'));
        if (hasApp || hasJudgeMe) {
          section.classList.add('is-ready');
          watchReveals(section);
          return;
        }
        if (++tries < 20) window.setTimeout(check, 500);
      })();
    });
  }

  function init(scope) {
    watchReveals(scope);
    setupUnfolds(scope);
    setupReviews(scope);
    (scope || document).querySelectorAll('[data-anv-recent]').forEach(fillRecent);
    if (!scope || scope === document) recordView();
  }

  if (!reduceMotion && !designMode) {
    // On desktop the theme scrolls inside .page-wrapper rather than the window, so listen for
    // scroll events from any element (capture phase), which also covers normal window scrolling.
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Theme editor: re-run when a section is added or re-rendered.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
